<div>
  <!-- pickup item.status -->
  <!-- PickUp:
new => En attente <br> d'enlévement (edited)
Assigned => Assigné
Declined => Refusé par chauffeur
Picked Up => Pickup assurée
Pickup terminée => Entrée au centrale (edited)  -->
  <div *ngIf="item.type == 'Appel'">
    <div class="badge history-badge badge-grey">
      Appel {{ item.duration ? "aboutis " + item.duration + " sec" : "" }}
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.createdAt | date: "dd/MM/yyyy HH:mm" }}
      </div>
      <div *ngIf="
          item?.link &&
          authService.credentials.user.userType == 'User' &&
          item.visibleToPartner
        " class="d-flex moveALittleToTop">
        <audio class="audioPlayer" controls src="{{ item?.link }}">
          Your browser does not support the
          <code>audio</code> element.
        </audio>
      </div>
    </div>
  </div>
  <div *ngIf="!item.jobRequest.pickUpJob && item.type != 'Appel'">
    <div class="badge history-badge badge-yellow" *ngIf="item.status == 1">
      En attente <br />
      d'enlévement

      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="badge history-badge badge-yellow" *ngIf="item.status == 2">
      En cours
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.jobRequest.dateAssign | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>

    <div class="badge history-badge badge-red" *ngIf="item.status == 4">
      Refusé <br />
      par chauffeur
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>

    <div class="badge history-badge badge-orange" *ngIf="item.status == 10">
      Pickup assurée
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.jobRequest.pickedUpDate | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="badge history-badge badge-green" *ngIf="item.status == 6">
      Entrée <br />
      au centrale
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.jobRequest.FinishJobDate | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>

    <!-- <br> -->
    <!-- <span *ngIf="item.status==6&&item.jobRequest?.centrale?.name">Centrale : {{item.jobRequest?.centrale?.name}}</span> -->
    <div class="shadow-none badge history-badge badge-red" *ngIf="item.status == 14">
      Annulée <br />
      par vendeur
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-red" *ngIf="item.status == 16">
      Retour <br />
      définitif
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.jobRequest.dateRetourDefinitif | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-red" *ngIf="item.status == 17">
      Retour <br />
      vendeur
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.jobRequest.dateRetourVendeur | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>

    <div class="shadow-none badge history-badge badge-green" *ngIf="item.status == 3">
      {{ "NOTIFICATION.STATUS.ACCEPTED" | translate }}
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-yellow" *ngIf="item.status == 5">
      {{ "NOTIFICATION.STATUS.STARTED" | translate }}
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-red" *ngIf="item.status == 7">
      {{ "NOTIFICATION.STATUS.DECLINED_LAST_MINUTE" | translate }}
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-red" *ngIf="item.status == 8">
      {{ "NOTIFICATION.STATUS.DECLINED_BY_ADMIN" | translate }}
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-red" *ngIf="item.status == 9">
      {{ "NOTIFICATION.STATUS.UNSUCCESSFUL" | translate }}
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.jobRequest.dateRetourProvisoire | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-red" *ngIf="item.status == 13">
      Adresse <br />
      manquante
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div>
      <span *ngIf="item.status == 18">
        <div class="shadow-none badge history-badge badge-orange pointer">
          Point Relais :
        </div>
        <br />
        <span>
          {{ item.jobRequest?.pointRelais?.address }}
        </span>
        <br />
        <span>
          {{ item.jobRequest?.pointRelais?.name }}
        </span>
        <br />
        <span>
          {{ item.jobRequest?.pointRelais?.tel }}
        </span>
      </span>
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.jobRequest.dateEntrePointRelais | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>

    <div class="shadow-none badge history-badge badge-yellow" *ngIf="item.status == 19">
      Retour point <br />
      relais
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-yellow" *ngIf="item.status == 20">
      Transfert <br />
      en cours
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>

    <div class="shadow-none badge history-badge badge-red" *ngIf="item.status == 21">
      Lost
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.jobRequest.lostDate | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-red" *ngIf="item.status == 22">
      Transfert <br />
      Annulé
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-green" *ngIf="item.status == 23">
      Échange <br />
      confirmé
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-yellow" *ngIf="item.status == 24">
      Retour vers <br />
      dépôt - {{ item.jobRequest?.centrale?.name }}
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-mauve" *ngIf="item.status == 25">
      En dépôt
      <div>{{ item.jobRequest?.centrale?.name }}</div>
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <!--<div
      class="shadow-none badge history-badge badge-blue"
      *ngIf="item.status == 27"
    >
      Transfert <br />
      Retour
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>-->
  </div>

  <!-- livraison item.status -->
  <!--
new => En attente <br> de livraison
Assigned => Assigné
Declined => Refusé par chauffeur
Picked up => Livraison en cours
Finished => Commande livrée
Retour au magazin => Retour provisoir <br> { Raison }
Retour difinitif => Retour difinitif
Retour au client => Retour vendeur
Canceled/ Declined by client => Annulée par vendeur
 -->

  <div class="badge history-badge badge-yellow" *ngIf="item.status == 2">
    Assigné
    <div class="f-11" *ngIf="showDateUnderBadge">
      {{ item.jobRequest.dateAssign | date: "dd/MM/yyyy HH:mm" }}
    </div>
  </div>

  <div *ngIf="item.jobRequest.pickUpJob && item.jobRequest.type != 'Appel'">
    <!--
    <div class="badge history-badge badge-yellow" *ngIf="item.status == 1">
      En attente <br />
      de livraison
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    -->
    <div class="badge history-badge badge-yellow" *ngIf="item.status == 2">
      Assigné
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.jobRequest.dateAssign | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="badge history-badge badge-red" *ngIf="item.status == 4">
      Refusé par <br />
      chauffeur
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="badge history-badge badge-orange" *ngIf="item.status == 10">
      Livraison <br />
      en cours
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="badge history-badge badge-green" *ngIf="item.status == 6">
      Livrée
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.jobRequest.FinishJobDate | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="badge history-badge badge-orange" *ngIf="item.status == 15">
      Retour <br />
      provisoire
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
      <div class="mt-2">
        {{ item.jobRequest?.failureReason }}
        <div class="f-11" *ngIf="item.jobRequest?.failureReason == 'Livraison reportée'">
          pour le {{ item.jobRequest?.reportedTo | date: "dd/MM/yyyy" }}
        </div>
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-red" *ngIf="item.status == 16">
      Retour <br />
      définitif
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.jobRequest.dateRetourDefinitif | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-red" *ngIf="item.status == 17">
      Retour <br />
      vendeur
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.jobRequest.dateRetourVendeur | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-red" *ngIf="item.status == 14">
      Annulée <br />
      par vendeur
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>

    <div class="shadow-none badge history-badge badge-green" *ngIf="item.status == 3">
      {{ "NOTIFICATION.STATUS.ACCEPTED" | translate }}
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-yellow" *ngIf="item.status == 5">
      {{ "NOTIFICATION.STATUS.STARTED" | translate }}
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-red" *ngIf="item.status == 7">
      {{ "NOTIFICATION.STATUS.DECLINED_LAST_MINUTE" | translate }}
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-red" *ngIf="item.status == 8">
      {{ "NOTIFICATION.STATUS.DECLINED_BY_ADMIN" | translate }}
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-red" *ngIf="item.status == 9">
      {{ "NOTIFICATION.STATUS.UNSUCCESSFUL" | translate }}
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.jobRequest.dateRetourProvisoire | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-red" *ngIf="item.status == 13">
      Adresse <br />
      manquante
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>

    <span *ngIf="item.status == 18">
      <div class="shadow-none badge history-badge badge-orange pointer">
        Point Relais
      </div>
      <br />
      <span class="ft-12">
        <span class="text-info"> adresse : </span>
        {{ item.jobRequest?.pointRelais?.address }}
      </span>
      <br />
      <span class="ft-12">
        <span class="text-info"> Nom : </span>
        {{ item.jobRequest?.pointRelais?.name }}
        <br />
        <span>
          {{ item.jobRequest?.pointRelais?.tel }}
        </span>
      </span>
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.jobRequest.dateEntrePointRelais | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </span>
    <div class="shadow-none badge history-badge badge-yellow" *ngIf="item.status == 19">
      Retour point <br />
      relais
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-yellow" *ngIf="item.status == 20">
      Transfert <br />
      en cours
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div *ngIf="item.status == 20">
      <span *ngIf="item?.jobRequest?.destinationCentral"> vers </span>
      {{ item.jobRequest?.destinationCentral?.name }}
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>

    <div class="shadow-none badge history-badge badge-red" *ngIf="item.status == 21">
      Lost
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.jobRequest.lostDate | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-green" *ngIf="item.status == 23">
      Échange <br />
      confirmé
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-yellow" *ngIf="item.status == 24">
      Retour vers <br />
      dépôt - {{ item.jobRequest?.centrale?.name }}
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-mauve" *ngIf="item.status == 25">
      En dépôt
      <div>{{ item.jobRequest?.centrale?.name }}</div>
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-blue" *ngIf="item.status == 27">
      Transfert retour
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>

    <div class="mt-2" *ngIf="
        item.status == 25 &&
        item.jobRequest?.failureReason == 'Livraison reportée'
      ">
      <div class="f-11">
        Livraison reportée <br />
        pour le {{ item.jobRequest?.reportedTo | date: "dd/MM/yyyy" }}
      </div>
    </div>
  </div>
</div>

<!-- item.status 4 partner -->
<div *ngIf="item.status4Partner && 0">
  <!-- item.status des pickup -->
  <!--
New == Assigned == Declined by driver ====> En attente <br> d'enlévement


     -->
  <div *ngIf="!item.jobRequest.pickUpJob">
    <div class="badge history-badge badge-yellow" *ngIf="item.status == 1 || item.status == 2 || item.status == 4">
      En attente <br />
      d'enlévement
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="badge history-badge badge-orange" *ngIf="item.status == 10">
      Pickup assurée <br />
      par INTIGO
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{
        item.jobRequest.pickedUpDate || item.updatedAt || item.date
        | date: "dd/MM/yyyy HH:mm"
        }}
      </div>
    </div>
    <div class="badge history-badge badge-green" *ngIf="item.status == 6">
      Entrée au <br />
      centrale
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.jobRequest.FinishJobDate | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-red" *ngIf="item.status == 14">
      Annulée <br />
      par vendeur
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-yellow" *ngIf="item.status == 5">
      {{ "NOTIFICATION.STATUS.STARTED" | translate }}
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
  </div>

  <!-- item.status des livraison -->
  <div *ngIf="item.jobRequest.pickUpJob">
    <!--
    <div
      class="badge history-badge badge-yellow"
      *ngIf="item.status == 1 || item.status == 2 || item.status == 4"
    >
      En attente <br />
      de livraison
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
   -->
    <div class="badge history-badge badge-orange" *ngIf="item.status == 10 || item.status == 5">
      Livraison <br />
      en cours
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.jobRequest.pickedUpDate | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="badge history-badge badge-green" *ngIf="item.status == 6">
      Livrée
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.jobRequest.FinishJobDate | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-red" *ngIf="item.status == 14">
      Annulée <br />
      par vendeur
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.updatedAt || item.date | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="badge history-badge badge-green" *ngIf="item.status == 15">
      Retour <br />
      provisoire <br />
      {{ item.jobRequest?.failureReason }}
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.jobRequest.dateRetourProvisoire | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-red" *ngIf="item.status == 16">
      Retour <br />
      définitif
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.jobRequest.dateRetourDefinitif | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
    <div class="shadow-none badge history-badge badge-red" *ngIf="item.status == 17">
      Retour <br />
      vendeur
      <div class="f-11" *ngIf="showDateUnderBadge">
        {{ item.jobRequest.dateRetourVendeur | date: "dd/MM/yyyy HH:mm" }}
      </div>
    </div>
  </div>
</div>

<!-- Modal edit -->
<div class="modal fade" style="position: absolute; top: 0; width: 100%; z-index: 99999" id="pointRelaisMap"
  tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="row">
          <div class="col text-center">
            <h5>
              {{ item.jobRequest?.pointRelais?.address }}
              {{ item.jobRequest?.pointRelais?.name }}
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div *ngIf="
                item.jobRequest?.pointRelais?.geoLocation?.coordinates?.length
              ">
              <agm-map style="
                  height: 250px;
                  width: 100%;
                  background-color: rgb(229, 227, 223);
                " [latitude]="
                  item.jobRequest.pointRelais.geoLocation.coordinates[0]
                " [longitude]="
                  item.jobRequest.pointRelais.geoLocation.coordinates[1]
                " [scrollwheel]="false" [zoom]="15">
                <agm-marker style="height: 14px !important" [latitude]="
                    item.jobRequest.pointRelais.geoLocation.coordinates[0]
                  " [longitude]="
                    item.jobRequest.pointRelais.geoLocation.coordinates[1]
                  ">
                </agm-marker>
              </agm-map>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" id="closeModal" data-dismiss="modal">
          <i class="flaticon-delete-1"></i> Discard
        </button>
      </div>
    </div>
  </div>
</div>